import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { loadPermissions, loadRoles } from "./rolesSlice";
import { setActiveRole, deleteRecord } from "../roleDetails/roleDetailsSlice";
import { useDispatch, useSelector } from "react-redux";
import { Table, Tag, Space, Button, Modal } from "antd";
import { FormattedMessage } from "react-intl";
import RoleForm from "../roleDetails/RoleForm";
import { deleteConfirmMessage } from "../../components/forms/formsFeedback";
import RestrictedComponent from "../../components/util/RestrictedComponent";
import { useIntl } from "react-intl";
import Surface from "../../components/layouts/Surface";

const Roles = (props) => {
  const { resource, action } = props;
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [mode, setMode] = useState(null);
  const roles = useSelector((state) => state.roles.roles);
  const intl = useIntl();
  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {
    dispatch(loadPermissions());
    dispatch(loadRoles());
  }, []);

  const columns = [
    {
      title: <FormattedMessage id={"app.roles.name"} />,
      dataIndex: "name",
      key: "name",
      width: "150px",
      render: (text) => <Tag>{text}</Tag>,
    },
    {
      title: <FormattedMessage id={"app.roles.description"} />,
      dataIndex: "description",
      key: "description",
    },
    {
      title: <FormattedMessage id={"app.roles.actions"} />,
      key: "action",
      width: "150px",
      dataIndex: "action",

      render: (text, record) => (
        <RestrictedComponent resource={resource} action={action} comp={null}>
          <Space size="middle">
            <Button type="text" onClick={() => editRole(record)}>
              <FormattedMessage id={"app.actions.edit"} />
            </Button>

            <Button danger type="text" onClick={() => onDelete(record)}>
              <FormattedMessage id={"app.actions.delete"} />
            </Button>
          </Space>
        </RestrictedComponent>
      ),
    },
  ];

  const addNewRole = (e) => {
    setVisible(true);
    setMode("new");
  };

  const handleCancel = (e) => {
    setVisible(false);
  };

  const editRole = (record) => {
    setVisible(true);
    setMode("edit");
    dispatch(setActiveRole(record));
  };

  const onDelete = (record) => {
    deleteConfirmMessage(
      intl,
      record.name,
      "roles",
      record.id,
      onConfirm,
      modal
    );
  };

  const onConfirm = async (id) => {
    await dispatch(deleteRecord(id));
    dispatch(loadRoles());
  };

  return (
    <Surface>
      <div style={{ width: "100%" }}>
        {contextHolder}
        <div
          style={{
            width: "100%",
            paddingBottom: "10px",
            justifyContent: "flex-end",
            display: "flex",
          }}
        >
          <RestrictedComponent resource={resource} action={action} comp={null}>
            <Button type="primary" onClick={addNewRole}>
              <FormattedMessage id={"app.roles.addRole"} />
            </Button>
          </RestrictedComponent>
        </div>

        <Table
          bordered
          rowKey={(record) => record.id}
          columns={columns}
          dataSource={roles}
          pagination={{ hideOnSinglePage: true }}
        />
        <Modal
          destroyOnClose={true}
          open={visible}
          footer={null}
          onCancel={handleCancel}
          title={null}
          width={"fit-content"}
          styles={{
            body: {
              padding: 0,
            },
          }}
          closable={false}
        >
          <RoleForm
            onHide={handleCancel}
            mode={mode}
            addText={
              mode === "new" ? (
                <FormattedMessage id={"app.roles.addRoleTitle"} />
              ) : (
                <FormattedMessage id={"app.roles.editRoleTitle"} />
              )
            }
          />
        </Modal>
      </div>
    </Surface>
  );
};

Roles.propTypes = {
  mode: PropTypes.string,
};

export default Roles;
